var _defs, _circle, _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "replyflowGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8B5CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#EC4899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F43F5E"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 60,
    fill: "url(#replyflowGradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 48 h48 a8 8 0 0 1 8 8 v20 a8 8 0 0 1-8 8 H64 l-12 12 v-12 H40 a8 8 0 0 1-8-8 V56 a8 8 0 0 1 8-8z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 58,
    width: 30,
    height: 4,
    rx: 2,
    fill: "#8B5CF6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 66,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#EC4899"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7c76ecfab9b5c6249b3edd5ea987fd33.svg";
export { ForwardRef as ReactComponent };